import router from '@/router';
import store from '@/store'
import { Notification } from 'element-ui';

/**
 * 网络通讯函数
 * @param {*} api eg: 自己/信息获取
 * @param {*} data
 */
const callApi = async function (api, data = null) {
    // 如果批量操作正在进行，则单个loading不再打开
    if (store.state.batchApiLoading === false && store.state.loading === false) store.commit('loading');

    const senddata = window.deepCopy(data);

    const headers = new Headers();
    headers.append('content-type', 'application/json;charset=utf-8');
    headers.append('username', encodeURI(window.sessionStorage.getItem('username')));
    headers.append('password', encodeURI(window.sessionStorage.getItem('password')));

    const request = new Request(process.env.VUE_APP_BASE_URL + api, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data),
        mode: 'cors',
        cache: 'default',
    });

    try {
        const res = await fetch(request);

        if (res.status !== 200) {
            throw '请求失败：' + res.status;
        }

        // 尝试格式化，若格式化失败，打印返回内容
        const text = await res.text();
        let response = '';
        try {
            response = JSON.parse(text);
        } catch {
            //延迟的目的是为了确保这条信息在控制台底部。
            setTimeout(() => {
                console.group('接口返回内容：')
                console.warn(text)
                console.groupEnd()
            }, 1000);

            throw '返回内容JSON格式化失败。';
        }

        // 打印通讯日志
        if (window.sessionStorage.getItem('username') === '刘智') {
            console.group('调用API：', api)
            console.info('发送数据：', senddata)
            console.info('返回数据：', window.deepCopy(response.data), window.deepCopy(response));
            console.groupEnd();
        }

        if (response.code <= 0) {
            if (response.url === '/登录') {
                window.sessionStorage.clear();
            }

            if (response.url && response.url !== 'javascript:history.back(-1);') {
                router.replace(response.url);
            }

            throw response.msg;
        }

        return response
    } catch (err) {
        console.error('callApi 通讯错误', err);

        err && Notification.error({
            title: '操作失败',
            message: err
        });

        throw err // 这里抛出错误可以中断函数调用
    } finally {
        if (store.state.loading) store.commit('loading', false)
    }
};


/**
 * callapi 批量版
 * @param {*} request_queue 请求队列
 */
const batchApi = async function (request_queue = [{
    api: '', // 请求的api
    data: '', // 请求的数据
    callback: null, //单个请求成功的回调
    errorCallBack: null,//单个请求失败的回调
}]) {

    store.state.batchApi.current_request = 0;
    store.state.batchApi.total_request = request_queue.length;
    store.state.batchApi.loading = true;

    for (let index = 0; index < request_queue.length; index++) {
        const request = request_queue[index];

        try {
            const response = await callApi(request.api, request.data);
            if (typeof request.callback === 'function')
                request.callback(response);

            store.state.batchApi.current_request = index + 1;
        } catch (error) {
            if (typeof request.errorCallBack === 'function')
                request.errorCallBack(error);

            store.state.batchApi.message = error; // 显示信息
            store.state.batchApi.continue_button = true;
            store.state.batchApi.cancel_button = true;
        }
    }

    store.state.batchApi.loading = false;
}

window.callApi = callApi;
window.batchApi = batchApi;

export {
    batchApi
}

export default callApi;